import {Sidebar} from "./sidebar.js";
import * as Potree from "../Potree";
import {EventTopic, NavigationMode, Utils, VolumeTool} from "../Potree";
import {Slider} from './Slider';

export class Quickbar {
    constructor(viewer) {
        this.viewer = viewer;
        this.areSlidersVisible = true;

        this.lengthSlider = new Slider(viewer, 'x', 'sldLength', 'horizontal', false, true);
        this.widthSlider = new Slider(viewer, 'y', 'sldWidth', 'horizontal', false, true);
        this.heightSlider = new Slider(viewer, 'z', 'sldHeight', 'vertical', true);
        this.sliders = [this.lengthSlider, this.widthSlider, this.heightSlider];

        this.onSceneChanged = this.onSceneChanged.bind(this);
        this.onBoundingBoxRecalculated = this.onBoundingBoxRecalculated.bind(this);
        this.onVolumeAdded = this.onVolumeAdded.bind(this);
        this.onVolumeRemoved = this.onVolumeRemoved.bind(this);

        this.viewer.addEventListener(EventTopic.SceneChanged, this.onSceneChanged);

        this.viewer.scene.addEventListener('volume_added', this.onVolumeAdded);
        this.viewer.scene.addEventListener('volume_removed', this.onVolumeRemoved);

        this.viewer.addEventListener('cliptask_changed', () => {
            const selectedVolume = this.viewer.scene.getSelectedVolume();

            if (selectedVolume) {
                this.updateSliders(selectedVolume);
            }
        });

        if (this.viewer.scene.volumes.length === 0) {
            $('#sldResetVolume').show();
            $('#sldDeleteVolume').hide();
        } else {
            $('#sldResetVolume').hide();
            $('#sldDeleteVolume').show();
        }

        this.viewer.transformationTool.addEventListener('scale_changed', ({object}) => this.updateSliders(object));
        this.viewer.transformationTool.addEventListener('position_changed', ({object}) => this.updateSliders(object));
        this.viewer.transformationTool.addEventListener('volume_handles_visible', ({areHandlesVisible}) => {
            const elShowHandles = document.querySelector('#sldShowHandles');
            elShowHandles.checked = areHandlesVisible;
        })
    }

    onVolumeAdded({volume}) {
        $('#sldResetVolume').hide();
        $('#sldDeleteVolume').show();

        volume.addEventListener('select', () => {
            this.updateSlidersAccessibility(true);

            const selectedVolume = this.viewer.scene.getSelectedVolume();
            if (selectedVolume) {
                this.updateSliders(selectedVolume);
            }
        });
        volume.addEventListener('deselect', () => this.updateSlidersAccessibility(false));
    }

    onVolumeRemoved() {
        if (this.viewer.scene.volumes.length === 0) {
            $('#sldResetVolume').show();
            $('#sldDeleteVolume').hide();
            this.updateSlidersAccessibility(true);
            this.updateSliders(this.viewer.scene.defaultClipVolume);
        }
    }

    createToolIcon(icon, title, callback, customCssClass) {
        let element = $(`
			<img src="${icon}"
				id="${title}"
				class="button-icon quickbar-icon ${customCssClass}"
				title="${title}" />
		`);

        element.click(callback);

        return element;
    };

    init() {
        this.initNavigation();
        this.initToolbar();
        this.initSliders();
        this.initSliderUIButtons();
    }

    initNavigation() {
        let elNavigation = $('#navBar');
        let sldMoveSpeed = $('#sldMoveSpeedQuickbar');
        let lblMoveSpeed = $('#lblMoveSpeedQuickbar');

        let isMobile = Utils.isMobileDevice();

        // Orbit
        elNavigation.append(this.createToolIcon(
            Potree.resourcePath + '/planquadrat/icons/orbit_controls.png',
            'Orbit',
            function () {
                viewer.setNavigationMode(NavigationMode.Orbit);
                Sidebar.hideMoveSpeedSlider();
                Quickbar.hideMoveSpeedSlider();
                Sidebar.selectNavigationIcon("Orbit");
            }
        ));

        if (!isMobile) {
            // Flight
            elNavigation.append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/flight_controls.png',
                'Flug',
                function () {
                    viewer.setNavigationMode(NavigationMode.Flight);
                    viewer.fpControls.lockElevation = false;
                    Sidebar.showMoveSpeedSlider();
                    Quickbar.showMoveSpeedSlider();
                    Sidebar.selectNavigationIcon("Flug");
                }
            ));

            // Earth
            elNavigation.append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/earth_controls.png',
                'Schiebe',
                function () {
                    viewer.setNavigationMode(NavigationMode.Earth);
                    Sidebar.hideMoveSpeedSlider();
                    Quickbar.hideMoveSpeedSlider();
                    Sidebar.selectNavigationIcon("Schiebe");
                }
            ));
        }

        // Focus
        elNavigation.append(this.createToolIcon(
            Potree.resourcePath + '/planquadrat/icons/focus_controls.png',
            'Zentrieren',
            function () {
                viewer.fitToScreen();
            }
        ));

        Sidebar.selectNavigationIcon("Orbit");

        let speedRange = new THREE.Vector2(1, 10 * 1000);

        let toLinearSpeed = function (value) {
            return Math.pow(value, 4) * speedRange.y + speedRange.x;
        };

        let toExpSpeed = function (value) {
            return Math.pow((value - speedRange.x) / speedRange.y, 1 / 4);
        };

        sldMoveSpeed.slider({
            value: toExpSpeed(viewer.getMoveSpeed()),
            min: 0,
            max: 1,
            step: 0.01,
            slide: function (event, ui) {
                viewer.setMoveSpeed(toLinearSpeed(ui.value));
            },
        });

        viewer.addEventListener('move_speed_changed', function (event) {
            lblMoveSpeed.html(viewer.getMoveSpeed()
                .toFixed(1));
            sldMoveSpeed.slider({ value: toExpSpeed(viewer.getMoveSpeed()) });
        });

        lblMoveSpeed.html(viewer.getMoveSpeed().toFixed(1));
        Quickbar.hideMoveSpeedSlider();
    }

    initToolbar() {
        let elToolbar = $('#toolBar');
        let measuringTool = new Potree.MeasuringTool(this.viewer);

        if (!Utils.isMobileDevice()) {
            // POINT
            elToolbar.append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/z_point.png',
                'Z-Wert',
                function () {
                    $('#menu_measurements').next().slideDown();
                    let measurement = measuringTool.startInsertion({
                        showDistances: false,
                        showAngles: false,
                        showCoordinates: true,
                        showCoordinatesX: false,
                        showCoordinatesY: false,
                        showArea: false,
                        closed: true,
                        maxMarkers: 1,
                        name: viewer.scene.getMeasurementName('Punkt')
                    });
                    Sidebar.selectToolIcon("Z-Wert");

                    let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
                    let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
                    $.jstree.reference(jsonNode.id).deselect_all();
                    $.jstree.reference(jsonNode.id).select_node(jsonNode.id);
                }
            ));

            // DISTANCE
            elToolbar.append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/distance.png',
                'Länge',
                function () {
                    $('#menu_measurements').next().slideDown();
                    let measurement = measuringTool.startInsertion({
                        showDistances: true,
                        showArea: false,
                        closed: false,
                        name: viewer.scene.getMeasurementName('Distanz')
                    });

                    let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
                    let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
                    $.jstree.reference(jsonNode.id).deselect_all();
                    $.jstree.reference(jsonNode.id).select_node(jsonNode.id);
                    Sidebar.selectToolIcon("Länge");
                }
            ));

            // HEIGHT
            elToolbar.append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/height.png',
                'Höhe',
                function () {
                    $('#menu_measurements').next().slideDown();
                    let measurement = measuringTool.startInsertion({
                        showDistances: false,
                        showHeight: true,
                        showArea: false,
                        closed: false,
                        maxMarkers: 2,
                        name: viewer.scene.getMeasurementName('Höhe')
                    });

                    let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
                    let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
                    $.jstree.reference(jsonNode.id).deselect_all();
                    $.jstree.reference(jsonNode.id).select_node(jsonNode.id);
                    Sidebar.selectToolIcon("Höhe");
                }
            ));
        }

        // REMOVE ALL
        elToolbar.append(this.createToolIcon(
            Potree.resourcePath + '/planquadrat/icons/reset_tools.png',
            'Entfernen',
            function () {
                if (confirm("Möchten Sie alle Messungen löschen?")) {
                    viewer.scene.removeAllMeasurements();
                    Sidebar.deselectToolIcons();
                }
            }
        ));
    }

    onSceneChanged(event) {
        event.oldScene.removeEventListeners(EventTopic.BoundingBoxRecalculated, this.onBoundingBoxRecalculated);
        event.oldScene.removeEventListeners('volume_added', this.onVolumeAdded);
        event.oldScene.removeEventListeners('volume_removed', this.onVolumeRemoved);
        event.scene.addEventListener(EventTopic.BoundingBoxRecalculated, this.onBoundingBoxRecalculated);
        event.scene.addEventListener('volume_added', this.onVolumeAdded);
        event.scene.addEventListener('volume_removed', this.onVolumeRemoved);
    }

    onBoundingBoxRecalculated(event) {
        const calculatedBoundingBox = event.calculatedBoundingBox;
        if (calculatedBoundingBox && calculatedBoundingBox.size) {
            const {size} = calculatedBoundingBox;
            this.sliders.forEach((slider) => slider.init(size));
        }
    }

    initSliders() {
        if (Utils.isMobileDevice()) {
            const elSliderVisibilityToggle = $("#slider-visibility-toggle");
            const elSliderWrapper = $(".slider-ui");

            if (elSliderVisibilityToggle.innerHTML) return;

            elSliderVisibilityToggle.append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/nav_toggle_up.png',
                'Toggle slider visibility',
                () => this.toggleSliderVisibility()
            ))

            elSliderVisibilityToggle.css({ display: 'block' });
            elSliderWrapper.css({bottom: '60px'});

            this.toggleSliderVisibility();
        }

        if (!this.viewer.scene.calculatedBoundingBox) {
            return;
        }
        const {size} = this.viewer.scene.calculatedBoundingBox;
        this.sliders.forEach((slider) => slider.init(size));
    }


    initSliderUIButtons () {
        const volumeTool = new VolumeTool(this.viewer);

        if (!Utils.isMobileDevice()) {
            $('#sldClipVolume').append(this.createToolIcon(
                Potree.resourcePath + '/icons/clip_volume.svg',
                'Volumen',
                () => {
                    volumeTool.startInsertion({
                        clip: true,
                        name: this.viewer.scene.getVolumeName('Volumen')
                    })

                    const volume = this.viewer.scene.volumes[this.viewer.scene.volumes.length - 1];
                    this.viewer.inputHandler.toggleSelection(volume);
                })
            );
        }

        $('#sldResetVolume').append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/reset.png',
                'Reset Volumen',
                () => this.resetVolumePosition(),
                'medium-icon'
            )
        );

        $('#sldDeleteVolume').append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/reset_tools.png',
                'Volumen Entfernen',
                () => {
                    if (confirm("Möchten Sie alle Ausschnitte löschen?")) {
                        viewer.scene.removeAllClipVolumes();
                    }
                }
            )
        );

        $('#sldLengthLock').append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/lock.png',
                'Lock Length Slider',
                () => this.lengthSlider.handleSliderLock(),
                'small-icon'
            )
        );

        $('#sldWidthLock').append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/lock.png',
                'Lock Width Slider',
                () => this.widthSlider.handleSliderLock(),
                'small-icon'
            )
        );

        $('#sldHeightLock').append(this.createToolIcon(
                Potree.resourcePath + '/planquadrat/icons/lock.png',
                'Lock Height Slider',
                () => this.heightSlider.handleSliderLock(),
                'small-icon'
            )
        );

        const elShowHandles = document.querySelector('#sldShowHandles');
        if (elShowHandles) {
            elShowHandles.checked = this.viewer.transformationTool.areHandlesVisible;
            elShowHandles.addEventListener('change', event => {
                this.viewer.transformationTool.setAreHandlesVisible(event.target.checked);
            });
        }
    }

    updateSliders(volume) {
        this.sliders.forEach((slider) => slider.updateSliderValues(volume));
    }

    updateSlidersAccessibility(isSelected) {
        this.sliders.forEach((slider) => slider.updateSliderAccessibility(isSelected));
    }

    resetVolumePosition() {
        let selectedVolume = this.viewer.scene.getSelectedVolume();

        if (selectedVolume) {
            selectedVolume.resetToInitialPosition();
            this.updateSliders(selectedVolume);
        } else if (!selectedVolume && this.viewer.scene.volumes.length === 0) {
            this.viewer.scene.resetDefaultClipVolumePosition();
            this.updateSliders(this.viewer.scene.defaultClipVolume);
        }

        this.unlockSliders();
    }

    unlockSliders() {
        this.sliders.forEach((slider) => {
            slider.setIsLocked(false)
            slider.updateSliderLockButton();
        });
    }

    toggleSliderVisibility() {
        let display = 'flex';

        if (this.areSlidersVisible) {
            display = 'none'
        }

        $('.slider-ui').css({display});
        this.areSlidersVisible = !this.areSlidersVisible;
    }

    static showMoveSpeedSlider() {
        $('#move_speed_container_quickbar')
            .css('display', 'block');
    }

    static hideMoveSpeedSlider() {
        $('#move_speed_container_quickbar')
            .css('display', 'none');
    }
}
